import { Buffer } from 'buffer';

export const parseTraceFromBuffer = (trace: string | Buffer) => {
  if (!trace) return [];

  let parsedTrace: number[] = [];

  const traceBuffer = Buffer.from(trace);

  //Fallback check for old trace style in ASCII
  if (
    traceBuffer.length % 2 === 0 &&
    (traceBuffer.at(0) !== 45 ||
      traceBuffer.at(3) !== 46 ||
      traceBuffer.at(6) !== 44)
  ) {
    const traceArray = Array.from(new Int16Array(traceBuffer.buffer));
    parsedTrace = traceArray.map((tracePoint) => tracePoint / 100.0);
  } else {
    //Fallback for old trace history format
    parsedTrace = traceBuffer.toString('utf8').split(',').map(Number);
  }

  return parsedTrace;
};

export const calcTraceMax = (previousTrace: number[], newTrace: number[]) => {
  if (!newTrace) return [];

  if (previousTrace.length < 1) return newTrace;

  let maxArray: number[] = [];

  for (let i = 0; i < newTrace.length; i++) {
    if (newTrace[i] > previousTrace[i]) {
      maxArray.push(newTrace[i]);
    } else {
      maxArray.push(previousTrace[i]);
    }
  }

  return maxArray;
};

export const calcTraceMin = (previousTrace: number[], newTrace: number[]) => {
  if (!newTrace) return [];

  if (previousTrace.length < 1) return newTrace;

  let minArray: number[] = [];

  for (let i = 0; i < newTrace.length; i++) {
    if (newTrace[i] < previousTrace[i]) {
      minArray.push(newTrace[i]);
    } else {
      minArray.push(previousTrace[i]);
    }
  }
  return minArray;
};
